import { Bath, Bed, LandPlot } from 'lucide-react';
import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CurrencyAmount from '@/components/currency-amount';
import { Button } from '@/components/ui/button';
import { type PatchedPropertyUnit } from '@/types';

export function PropertyLegendMobile({
  property,
  availableColor,
  soldColor,
  openInNewTab,
}: {
  property: PatchedPropertyUnit;
  availableColor: string;
  soldColor: string;
  openInNewTab?: boolean;
}) {
  const { t, i18n } = useTranslation();

  return (
    <div className="-translate-y-1 md:absolute md:top-3 md:right-3">
      <div className="bg-white p-4 relative w-full border-b border-gray-200 rounded-t-xl md:rounded-xl md:w-auto md:shadow-md md:bg-opacity-80">
        <div className="flex items-center justify-between md:flex-col md:items-start md:justify-start md:gap-y-2">
          <h1 className="font-bold">
            <CurrencyAmount className="text-3xl" amount={property.priceOfSale} currency="EUR" />
          </h1>
          <Button asChild>
            <Link
              target={openInNewTab ? '_blank' : undefined}
              href={`/${i18n.language}/project/${property.project?.slug}/property/${property.slug}`}
            >
              {t('property.selector.legend.view-property')}
            </Link>
          </Button>
        </div>
        <div className="mt-2 grid grid-cols-2 sm:grid-cols-4 md:grid-cols-1">
          <div className="mt-2 flex items-center text-lg text-gray-800">
            <span className="font-medium mr-1">
              {property.state === 'available'
                ? t('property.selector.legend.available')
                : t('property.selector.legend.sold')}
            </span>
            <span
              className="block h-4 w-4 rounded-full"
              style={{
                backgroundColor: property.state === 'available' ? availableColor : soldColor,
              }}
            />
          </div>
          <div className="text-lg flex items-center">
            <Bed className="block mr-2" />
            <p className="font-medium">
              {property?.bedrooms} {t('property.selector.legend.beds')}
            </p>
          </div>
          <div className="text-lg flex items-center">
            <Bath className="block mr-2" />
            <p className="font-medium">
              {property?.bathrooms} {t('property.selector.legend.baths')}
            </p>
          </div>
          <div className="text-lg flex items-center">
            <LandPlot className="block mr-2" />
            <p>
              {property.builtArea}
              <span className="text-base">m²</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
